export default "__VITE_ASSET__CS2$n03W__"